<template>
    <div>
        <mobile-search-form v-model="searchPrecios" placeholder="Buscar Registros"></mobile-search-form>
        <page-title-bar :class-container="$vuetify.breakpoint.smAndDown ? '' : 'pa-0'">
            <template slot="actions">
                <v-text-field clearable flat solo prepend-icon="search" v-model="searchPrecios" placeholder="Buscar Registros" class="search-bar"></v-text-field>
                <div class="mobile-search d-none">
                    <v-tooltip top>
                        <v-btn slot="activator" icon large class="mobile-search-btn" @click="toggleSearchForm">
                            <v-icon color="grey">search</v-icon>
                        </v-btn>
                        <span>Buscar Registros</span>
                    </v-tooltip>
                </div>
                <v-tooltip top>
                    <v-btn slot="activator" icon large @click="getPrecios">
                        <v-icon color="grey">ti ti-reload</v-icon>
                    </v-btn>
                    <span>Recargar</span>
                </v-tooltip>
            </template>
        </page-title-bar>
        <v-container fluid grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pa-2'">
            <v-layout row wrap border-rad-sm overflow-hidden>
                <v-flex xs12>
                    <v-data-table
                            :headers="headers"
                            :items="registrosTabla"
                            disable-initial-sort
                            hide-actions
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.cant }}</td>
                            <td>
                                <a @click="getDetalleTechnologi(props.item.TipoTec, props.item.CodSerTec)">{{`${props.item.TipoTec} ${props.item.CodSerTec}`}}</a>
                            </td>
                            <v-hover>
                                <td class="text-xs-right" slot-scope="{ hover }" width="250">
                                    <v-text-field
                                            v-if="hover && permisos.add"
                                            :key="`Precio${props.index}`"
                                            autofocus
                                            v-model.number="props.item.precio"
                                            :loading="props.item.loading"
                                            :name="`nameprecio${props.index}`"
                                            type="number"
                                            min="0"
                                            prepend-inner-icon="fas fa-dollar-sign"
                                            v-validate="'min_value:0|decimal:2'"
                                            data-vv-as="Precio"
                                            :error-messages="errors.collect(`nameprecio${props.index}`)"
                                            @input="cambiarPrecio(props)"
                                    ></v-text-field>
                                    <span v-else>{{ props.item.precio ? currency(props.item.precio) : '$ _' }}</span>
                                </td>
                            </v-hover>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="loader = false"></detail-technologi-dialog>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>

<script>
    export default {
        name: 'Precios',
        components: {
            MobileSearchForm: () => import('@/components/Header/MobileSearchForm')
        },
        data: () => ({
            loader: false,
            searchPrecios: '',
            precios: [],
            headers: [
                {
                    text: 'Cantidad',
                    sortable: true,
                    value: 'cant'
                },
                {
                    text: 'Servicio y/o Tecnología',
                    sortable: false
                },
                {
                    text: 'Precio Unitario',
                    align:'left',
                    sortable: true,
                    value: 'precio'
                }
            ]
        }),
        computed: {
            permisos () {
                return this.$store.getters.getPermissionModule('precios')
            },
            registrosTabla () {
                this.searchPrecios = this.searchPrecios || ''
                return this.precios.filter(x => (`${x.TipoTec} ${x.CodSerTec}`).toLowerCase().search(this.searchPrecios.toLowerCase()) !== -1)
            }
        },
        created () {
            this.getPrecios()
        },
        methods: {
            cambiarPrecio: window.lodash.debounce(function (props) {
                props.item.loading = true
                if (props.item.precio !== '' && !isNaN(props.item.precio)) {
                    this.axios.put(`precios`, props.item)
                        .then(response => {
                            console.log('response del put', response)
                            props.item.loading = false
                        }).catch(e => {
                        props.item.loading = false
                        props.item.precio = null
                        this.$store.commit('snackbar', {color: 'error', message: `al asignar el precio al servicio/tecnología ${props.item.TipoTec} ${props.item.CodSerTec}`, error: e})
                    })
                } else {
                    setTimeout(() => {
                        props.item.loading = false
                        props.item.precio = null
                        this.$store.commit('snackbar', {color: 'error', message: `El valor ingresado no es un número válido`})
                    }, 1000)
                }
            }, 500),
            // cambiarPrecio (props) {
            //     props.item.loading = true
            //     if (props.item.precio !== '' && !isNaN(props.item.precio)) {
            //         this.axios.put(`precios`, props.item)
            //             .then(response => {
            //                 console.log('response del put', response)
            //                 props.item.loading = false
            //             }).catch(e => {
            //             props.item.loading = false
            //             props.item.precio = null
            //             this.$store.commit('snackbar', {color: 'error', message: `al asignar el precio al servicio/tecnología ${props.item.TipoTec} ${props.item.CodSerTec}`, error: e})
            //         })
            //     } else {
            //         setTimeout(() => {
            //             props.item.loading = false
            //             props.item.precio = null
            //             this.$store.commit('snackbar', {color: 'error', message: `El valor ingresado no es un número válido`})
            //         }, 1000)
            //     }
            // },
            getDetalleTechnologi (type, code) {
                this.loader = true
                this.$refs.dialogInfoTechnologi.getDetail(type, code)
            },
            getPrecios () {
                this.loader = true
                this.axios.get(`precios`)
                    .then(response => {
                        response.data.map(x => {
                            x.loading = false
                        })
                        this.precios = response.data
                        this.loader = false
                    }).catch(e => {
                    this.loader = false
                    this.$store.commit('snackbar', {color: 'error', message: `al recuperar los servicios y/o tecnologías`, error: e})
                })
            },
            toggleSearchForm() {
                this.$store.dispatch('toggleSearchForm')
            }
        }
    }
</script>

<style scoped>

</style>